export default __webpack_public_path__ + "static/spiritual-christian-shrines-3-e2ac77ff846882cc4774c869c584fe73.jpg";